// @ts-ignore
import React, { useState, useEffect } from 'react';
import { Accordion, Card, Button, Form, OverlayTrigger, ToastContainer, Toast,} from 'react-bootstrap';
// @ts-ignore
import { FaBriefcase, FaChevronDown, FaChevronRight, FaDatabase, FaEye, FaPlug, FaTable, FaTasks} from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-circular-progressbar/dist/styles.css';
import DetailCard from './DetailCard';
import "./index.scss"
import empty from "../../../src/assets/images/empty.png"; 
import arrowRight from "../../../src/assets/images/arrow-right.png";
import SettingIcon from "../../components/Icons/JobSettingIcon.svg";
import Wait from "../../../src/assets/images/icons8-two-hands-100.png"
import CompareTarget from './CompareTarget';
import CenteredModal from './DeploymentPckDetailsLoader';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
// @ts-ignore
import { CustomPlugin, DataSource, DynamicMappingConfig, Environment, JobTaskGroupVersion2, JobTaskVersion2, JobVersion2, TargetEntities } from './interfaces';
import { useMetaDataDeployment, ViewTargetInfo } from "./useMetaDataDeploymentHook"
import DropZoneCard from './DropZoneCard';
import JobTaskGroupIcon from "../../components/Icons/JobTaskGroupSettingIcon.svg";
import imggg from "../../components/Icons/bronze.png"
import imgggGold from "../../components/Icons/gold.png"

const ICONS = {
  1: imggg,  // bronze
  2: JobTaskGroupIcon,  // silver
  3: imgggGold,  // gold
} as const;

export function getTierIcon(tier: 1 | 2 | 3): JSX.Element {
  return (
    <img
      src={ICONS[tier]}
      alt="tier icon"
      height={tier === 2 ? 18 :20}
      style={{
        marginLeft: tier === 2 ? '0.8rem' :'0.5rem',
        marginRight: '0.5rem',
      }}
    />
  );
}



const statusMapping = (status: string | null) => {
  switch (status) {
    case "NEW":
      return "green";
    case "UPDATED":
      return "blue";
    case "DELETED":
      return "red";
    case "NO_CHANGE":
      return "grey";
    default:
      return "inherit";
  }
};

const hasChangedDependencyStatus = (
  dependencies: any[] | undefined,
  statusKey: string
) => {
  if (!Array.isArray(dependencies)) return false;
  return dependencies.some((dep) => {
    const status = dep?.[statusKey];
    return (
      typeof status === "string" &&
      status.toUpperCase() !== "NO_CHANGE"
    );
  });
};

const JobList: React.FC = () => {

  const   storedJobsArray = JSON.parse(localStorage.getItem('jobsArray')) || [];

  const {

    jobs,
    setJobs,
    initialJobList,
    expandedItems,
    filteredItems,
    packageId,
    setPackageId,
    droppedJobs,
    draggedElement,
    position,
    isDragging,
    selectedTargets,
    setSelectedTargets,
    packageDeploymentExecution,
    showProgress,
    setShowProgress,
    jobToShowProgressFor,
    setJobsToShowProgressFor,
    environments,
    showInitialSelectionModalLoader,
    tableNames,
    initialView,
    selectedTargetEntities,
    selectedViewTargets,
    // isTier1NewChecked,
    tier1NewCheckedJobs,
    targetEnvironmentId,
    hasColumnChangeReasonTaskName,
    hasColumnChangeReason,
    loading,
    emptyResultWarning,
    childEntityUpdate,
  // _ hasDependencyUpdate,
    // hasTaskGroupDependencyUpdate,
    handleJobSelect,
    handleTaskGroupSelect,
    handleJobTaskSelect,
    togglePanel,
    handleJobDrop,
    handleDragStart,
    handleJobCompletion,
    extractTargetInfo,
    setSelectedTargetEntities,
    setSelectedViewTargets,
    setTier1NewCheckedJobs,
    adjustOtherGroupsOnTier1NewDeselect,
    resetAllStates,
    setEmptyResultWarning,
    areAllJobsSelected,
    handleSelectAllJobs,
    // useScreenWidth
    } = useMetaDataDeployment()

  const importDeploymentBreadCrumbData: { name: string; url: string }[] = [
    {
      name: "Deployment",
      url: "/metaDataDeployment",
    },
    {
      name: "Deployment History",
      url: "/deploymentHistory",
    }
  ];

  const groupTasksByName = (tasks: JobTaskVersion2[]) => {
    const taskMap: Record<string, JobTaskVersion2[]> = {};
    for (const task of tasks) {
      const name = task.job_task_name;
      if (!taskMap[name]) {
        taskMap[name] = [];
      }
      taskMap[name].push(task);
    }
    return taskMap;
  };

  const toggleTasksInGroup = (
    jobId: number,
    taskGroupId: number,
    taskGroup: JobTaskVersion2[]
  ) => {
    const shouldSelect = taskGroup.some(t => !t.selected);
    const selectedSet = new Set(selectedTargetEntities);
  
    const updatedJobs = jobs.map(job => {
      if (job.job_id === jobId) {
        const updatedTaskGroups = job.job_task_groups.map(tg => {
          if (tg.job_task_group_id === taskGroupId) {
            const updatedTasks = tg.job_tasks.map(task => {
              if (taskGroup.some(t => t.job_task_id === task.job_task_id)) {
                // extract target info for this task
                const relatedTargets = extractTargetInfo([task], initialView);
  
                // update target entity checkbox state too
                for (const ti of relatedTargets) {
                  const key = `${ti.target_entity_name}-${ti.target_entity_table_constructor}`;
                  if (shouldSelect) {
                    selectedSet.add(key);
                  } else {
                    selectedSet.delete(key);
                  }
                }

                for (const ti of relatedTargets) {
                  const key = `${ti.target_entity_name}-${ti.target_entity_table_constructor}`;
                
                  if (shouldSelect) {
                    selectedSet.add(key);
                
                    const alreadyExists = selectedViewTargets.some(
                      v =>
                        v.target_entity_name === ti.target_entity_name &&
                        v.target_entity_table_constructor === ti.target_entity_table_constructor
                    );
                
                    if (!alreadyExists) {
                      selectedViewTargets.push({
                        ...ti,
                        target_entity_mapping: [...ti.target_entity_mapping],
                        source_target_entity_mapping: [...ti.source_target_entity_mapping],
                      });
                    }
                  } else {
                    selectedSet.delete(key);
                  }
                }
  
                return {
                  ...task,
                  selected: shouldSelect,
                  data_sources: (task.data_sources ?? []).map((ds:any) => ({ ...ds, selected: shouldSelect })),
                  custom_plugins: (task.custom_plugins ?? []).map((cp:any) => ({ ...cp, selected: shouldSelect })),
                  target_entities: (task.target_entities ?? []).map((te: any) => ({ ...te, selected: shouldSelect })),
                  job_steps: (task.job_steps ?? []).map((js: any) => ({ ...js, selected: shouldSelect }))
                };
              }
              return task;
            });
  
            const taskGroupSelected = updatedTasks.some(t => t.selected);
  
            return {
              ...tg,
              selected: taskGroupSelected,
              job_tasks: updatedTasks
            };
          }
          return tg;
        });
  
        const jobSelected = updatedTaskGroups.some(tg => tg.selected);
  
        return {
          ...job,
          selected: jobSelected,
          job_task_groups: updatedTaskGroups
        };
      }
      return job;
    });

    const finalUpdatedJobs = updatedJobs.map(job => {
      // If the currently toggled group is Tier 1 + NEW
      const affectedGroup = job.job_task_groups.find(
        tg =>
          tg.job_task_group_id === taskGroupId &&
          tg.job_task_group_layer_id === 1 &&
          tg.job_task_group_status === "NEW"
      );

      if (affectedGroup && !affectedGroup.selected) {
        // 🧨 Deselect Tier 2 & 3 groups and their tasks/entities
        return adjustOtherGroupsOnTier1NewDeselect([job])[0];
      }

      return job;
    });

    const fullySyncedJobs = finalUpdatedJobs.map(job => {
      const anyGroupSelected = job.job_task_groups.some(tg => tg.selected);
      return {
        ...job,
        selected: anyGroupSelected
      };
    });

    setJobs(fullySyncedJobs);
    setSelectedTargetEntities(selectedSet);
    const filteredViewTargets = Array.from(selectedSet).map(key => {
      const [name, table] = key.split("-");
      return selectedViewTargets.find(
        v =>
          v.target_entity_name === name &&
          v.target_entity_table_constructor === table
      );
    }).filter(Boolean); // removes undefined
    
    setSelectedViewTargets(filteredViewTargets);

    const updatedTier1NewStatus = updatedJobs.reduce((acc, job) => {
      const tier1NewSelected = job.job_task_groups.some(
        tg =>
          tg.job_task_group_layer_id === 1 &&
          tg.job_task_group_status === "NEW" &&
          (tg.selected || tg.job_tasks.some(task => task.selected))
      );
      acc[job.job_id] = tier1NewSelected;
      return acc;
    }, {} as { [jobId: number]: boolean });

    setTier1NewCheckedJobs(updatedTier1NewStatus);
    setShowProgress(false);
  };

  const getTargetKey = (ti: {
    target_entity_name: string;
    target_entity_table_constructor: string;
  }) => `${ti.target_entity_name}-${ti.target_entity_table_constructor}`;

  const handleTargetInfoSelect = (
    targetKey: string,
    ti: ViewTargetInfo
  ) => {
    const newKey = `${ti.target_entity_name}-${ti.target_entity_table_constructor}`;
    const updatedSet = new Set(selectedTargetEntities);
  
    if (updatedSet.has(newKey)) {
      updatedSet.delete(newKey);
    } else {
      updatedSet.add(newKey);
    }
  
    setSelectedTargetEntities(updatedSet);
  
    // Sync view-level selection state
    setSelectedViewTargets(prev => {
      const keyToToggle = getTargetKey(ti);
    
      const exists = prev.some(
        v =>
          getTargetKey({
            target_entity_name: v.target_entity_name ?? '',
            target_entity_table_constructor: String(v.target_entity_table_constructor ?? '')
          }) === keyToToggle
      );
    
      if (exists) {
        // Deselect (filter out matching one)
        return prev.filter(
          v =>
            getTargetKey({
              target_entity_name: v.target_entity_name ?? '',
              target_entity_table_constructor: String(v.target_entity_table_constructor ?? '')
            }) !== keyToToggle
        );
      } else {
        // Select (add unique object)
        return [
          ...prev,
          {
            ...ti,
            target_entity_mapping: [...ti.target_entity_mapping],
            source_target_entity_mapping: [...ti.source_target_entity_mapping],
          },
        ];
      }
    });
  };

  const renderJobTasks = (jobId: number, taskGroupId: number, tasks: JobTaskVersion2[], layerId:number, job_task_group_dependency_exist: boolean) => {
    const groupedTasks = groupTasksByName(tasks);
    
  
    return (
      <Accordion className="metadata-tree metadata-tree--tasks">
        <div className="metadata-tree-notice-row">
           {job_task_group_dependency_exist && <span className="metadata-tree-notice">
                            Job Task Group Dependency Change Detected                             
                            </span>

              }
        </div>
        {Object.entries(groupedTasks).map(([taskName, taskGroup]) => {
          const isAggregatedSelected = taskGroup.some(t => t.selected);
          const expandedKey = taskGroup.map(t => t.job_task_id).join("-");
          const targetColumnPruneReasonKeys = Array.from(
            new Set(taskGroup.flatMap(task => task._targetColumnPruneReasonKeys ?? []))
          );

          const uniqueTargetInfos = Array.from(
            new Map(
              taskGroup
                .flatMap(task => extractTargetInfo([task], initialView))
                .map(ti => [
                  `${ti.target_entity_name}-${ti.target_entity_table_constructor}`, // Unique key
                  ti,
                ])
            ).values()
          );
          
          return (
            <div key={expandedKey} className="metadata-tree-row metadata-tree-row--task">
              <Card.Header className="jobtask-row-header metadata-tree-row__header metadata-tree-row__header--task">
                <Form.Check
                  className="metadata-tree-check"
                  type="checkbox"
                  label={
                    <div className="jobtask-label">
                      <div className="jobtask-label__main">
                        <span className="jobtask-label__name">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <div id={`tooltip-${taskName}`} style={{ background: "white", padding: "10px", borderRadius: "10px", border: "1px solid black" }}>
                                {`${taskName}`}
                              </div>
                            }
                          >
                            <span className="jobtask-label__nameText">
                              <FaTasks style={{ color: '#29527a', fontSize: '1rem' }} />
                              {taskName}
                            </span>
                          </OverlayTrigger>
                        </span>
                        <span className="jobtask-label__status">
                          {!taskGroup?.some(
                            (item) => Array.isArray(item.source_entitys) && item.source_entitys.length > 0
                          ) && (
                            <span className="metadata-status-pill" style={{ color: statusMapping(taskGroup[0]?.job_task_status) }}>
                              {taskGroup[0]?.job_task_status}
                            </span>
                          )}
                        </span>
                      </div>
                      {targetColumnPruneReasonKeys.length > 0 && (
                        <div className="jobtask-label__reason">
                        {targetColumnPruneReasonKeys.join(" and ")} changed.
                        </div>
                      )}
                    </div>
                  }
                  checked={isAggregatedSelected}
                  onChange={() => {
                    toggleTasksInGroup(jobId, taskGroupId, taskGroup)
                  }}
                />
                <Button className="metadata-tree-toggle" variant="link" onClick={() => togglePanel(taskGroup[0].job_task_id)}>
                  {expandedItems.has(taskGroup[0].job_task_id) ? <FaChevronDown/> : <FaChevronRight/>}
                </Button>
              </Card.Header>
  
              <Accordion.Collapse eventKey={String(taskGroup[0].job_task_id)} in={expandedItems.has(taskGroup[0].job_task_id)}>
                <Card.Body className="metadata-tree-body">
                  {taskGroup.flatMap(task =>{

                    // const isSpecial = taskGroup.length === 1 && !!task.job_task_target_entity_id;
                    const isSpecial =
                    taskGroup.length === 1 &&
                    (
                      !!task.target_entity_rdvs?.[0]?.target_entity_rdv_id ||
                      !!task.target_entity_dms?.[0]?.target_entity_dm_id
                    ) && !task.target_entity_table_constructor?.includes('AsView') &&
                          !task.target_entity_table_constructor?.includes('View');;

                    return task.job_steps?.map((step, stepIdx) => {
                      if (isSpecial) {
                        return (
                          <div
                            key={`special-step-${task.job_task_id}-${stepIdx}`}
                            className="metadata-leaf-row"
                          >
                            <span style={{ fontSize: "14px", display:"flex", flexDirection:"row", alignItems:"center", gap:"20px" }}>
                              <FaTable size={25} color={layerId === 2 ? "silver" : layerId === 3 ? "gold" : ""} />
                              <OverlayTrigger
                              placement="top"
                              overlay={
                                <div
                                  style={{
                                    background: "white",
                                    padding: "10px",
                                    borderRadius: "10px",
                                    border: "1px solid black",
                                    maxWidth: "300px",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {taskName}
                                </div>
                              }
                            >
                              <span
                                style={{
                                  color: "black",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "80px", // Adjust as needed
                                  // fontWeight: "500",
                                  display: "inline-block",
                                  verticalAlign: "middle",
                                  cursor: "pointer",
                                }}
                              >
                                {taskName}
                              </span>
                            </OverlayTrigger>
                              <span className="metadata-leaf-row__detail">{step.job_step_name} ({task.target_entity_table_constructor})</span>
                            </span>
                            <span style={{
                              color: statusMapping(task.target_entity_rdv_status ?? task.target_entity_dm_status ?? '-'),
                            }}>
                              {task.target_entity_rdv_status ?? task.target_entity_dm_status ?? '-'}
                            </span>
                          </div>
                        );
                      }
                      
                      if(task?.job_task_custom_plugin_id){
                      return (
                        <Form.Check
                          className="metadata-leaf-check"
                          key={`${task.job_task_id}-${step.job_step_name}`}
                          type="checkbox"
                          label={
                            <>
                              <div style={{ display:"flex", flexDirection:"row", alignItems:"center", gap:"20px" }}>
                                {step.source_entity_name && <FaTasks style={{ color: '#29527a', fontSize: '1rem' }} />}
                                <span style={{ fontSize: "14px" }}>
                                  {
                                    !step.source_entity_name &&
                                    <FaPlug size={25} style={{marginRight:"16px",}} color="black"/>
                                  }
                                  {Array.isArray(task?.custom_plugins) && task.custom_plugins.length > 0 ? (
                                    <>
                                    <span
                                      style={{
                                        // color: statusMapping(task?.custom_plugins[0]?.custom_plugin_status),
                                        // fontSize: "14px",
                                        // fontWeight: "500",
                                        // paddingTop: "5px",
                                        marginRight:"2px"
                                      }}
                                    >
                                      {task?.custom_plugins[0]?.custom_plugin_name}
                                    </span>
                                    /
                                    <span
                                      style={{
                                        // color: statusMapping(task?.custom_plugins[0]?.custom_plugin_status),
                                        // fontSize: "14px",
                                        // fontWeight: "500",
                                        // paddingTop: "5px",
                                        marginLeft:"2px"
                                      }}
                                    >
                                      {step.job_step_name}
                                    </span>
                                    </>
                                  ) :
                                  <>
                                  {step.job_step_name}
                                  </>
                                }
                                </span>
                                <div style={{display:"flex", flexDirection:"row", gap:"20px", alignItems:"center"}}>
                                  {/* <span style={{ fontSize: "12px" }}>{step.data_source_name && `${step.source_entity_name}/${step.data_source_name}`}</span> */}
                                  {/* {task.job_task_status !== "No Change" && task.job_task_status !== null && !task?.custom_plugins?
                                    <span style={{
                                      color:statusMapping(task.job_task_status),
                                      fontSize:"14px",
                                      fontWeight:"500",
                                      paddingTop:"5px"
                                      }}
                                    >
                                      {task.job_task_status}
                                    </span>
                                    :
                                    Array.isArray(task?.custom_plugins) &&
                                    <span style={{
                                      color:statusMapping(task?.custom_plugins[0]?.custom_plugin_status),
                                      fontSize:"14px",
                                      fontWeight:"500",
                                      paddingTop:"5px"
                                      }}
                                    >
                                      {task?.custom_plugins[0]?.custom_plugin_status}
                                    </span>
                                  } */}
                                  {Array.isArray(task?.custom_plugins) && task.custom_plugins.length > 0 ? (
                                    
                                    <span
                                      style={{
                                        color: statusMapping(task?.custom_plugins[0]?.custom_plugin_status),
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        paddingTop: "5px",
                                      }}
                                    >
                                      {task?.custom_plugins[0]?.custom_plugin_status}
                                    </span>
                                  ) : (
                                    // ✅ Case: no custom plugin → use job_task_status
                                    task.job_task_status &&
                                    task.job_task_status !== "No Change" && (
                                      <span
                                        style={{
                                          color: statusMapping(task.job_task_status),
                                          fontSize: "14px",
                                          fontWeight: "500",
                                          paddingTop: "5px",
                                        }}
                                      >
                                        {task.job_task_status}
                                      </span>
                                    )
                                  )}
                                </div>
                              </div>
                            </>
                          }
                          checked={step.selected}
                          onChange={() => handleJobTaskSelect(jobId, taskGroupId, task.job_task_id)}
                        />
                      );}
                      return(
                      uniqueTargetInfos.map((ti, index) => (
                        <Form.Check
                          className="metadata-leaf-check"
                          key={`target-info-unique-${index}`}
                          type="checkbox"
                          label={
                          <div className="metadata-target-leaf">
                            <div className="metadata-target-leaf__details">
                              <CompositeTableEyeIcon size={30} eyeSize={24}/>
                              {`${ti.target_entity_name} (${ti.target_entity_table_constructor})`}
                            </div>
                            <div className="metadata-target-leaf__status">
                                      {/* <span style={{ fontSize: "12px" }}>{step.data_source_name && `${step.source_entity_name}/${step.data_source_name}`}</span> */}
                                      {ti.target_entity_status !== "No Change" && ti.target_entity_status !== null && 
                                        <span className="metadata-status-pill" style={{
                                          color:statusMapping(ti.target_entity_status),
                                          }}
                                        >
                                          {ti.target_entity_status}
                                        </span>
                                      }
                            </div>
                            </div>
                          }
                          checked={selectedTargetEntities.has(`${ti.target_entity_name}-${ti.target_entity_table_constructor}`)}
                          onChange={() =>
                            handleTargetInfoSelect(
                              `${ti.target_entity_name}-${ti.target_entity_table_constructor}`,
                              ti,
                            )
                          }
                        />
                      ))
                    )
                    });
                    }
                  )}
                  
                  
                  {
                    <>
                      {Array.from(
  new Set(
    taskGroup.flatMap(task =>
      task.job_steps
        ?.filter(step => step.source_entity_name)
        ?.map(step => `${step.source_entity_name}/${step.data_source_name}`)
    )
  )
).map((uniqueSource, idx) => {
  // tasks tied to this unique source
  const relatedTasks = taskGroup?.filter(task =>
    task.job_steps?.some(
      step => `${step.source_entity_name}/${step.data_source_name}` === uniqueSource
    )
  ) ?? [];

  // Helper: prioritize statuses (change > no change)
  const rank = (s?: string) => {
    const v = (s ?? "").toUpperCase();
    // adjust ordering if you prefer NEW > UPDATED > DELETED, etc.
    if (v === "UPDATED") return 0;
    if (v === "NEW") return 1;
    if (v === "DELETED") return 2;
    if (v && v !== "NO_CHANGE") return 3; // any other non-NO_CHANGE
    return 999; // NO_CHANGE or empty
  };

  // Find the strongest status among matching source entities
  let bestStatus: string | undefined;
  for (const task of relatedTasks) {
    const stepsForThisSource = task.job_steps?.filter(
      step => `${step.source_entity_name}/${step.data_source_name}` === uniqueSource
    ) ?? [];

    for (const step of stepsForThisSource) {
      // try to match the source entity by name; if your model also has data_source_name
      // inside `source_entitys[]`, include it in the match too.
      const match = (task.source_entitys ?? []).find((se:any) =>
        se?.source_entity_name === step.source_entity_name
        // If available in your data, also check DS name:
        // && se?.data_source_name === step.data_source_name
      );

      const st = match?.source_entity_status;
      if (bestStatus === undefined || rank(st) < rank(bestStatus)) {
        bestStatus = st;
      }
    }
  }

  // Fallback text if nothing matched
  const displayStatus = bestStatus ?? "NO_CHANGE";

  // Column-level reason (unchanged from your code)
  const anyHasColumnReason = relatedTasks.some(task =>
    hasColumnChangeReasonTaskName.includes(task.job_task_name)
  );

  return (
    <div
      key={`unique-source-${idx}`}
      className="metadata-leaf-source"
    >
      <span
        className="metadata-leaf-source__title"
      >
        <FaTable size={25} color="#CD7F32" />
        {uniqueSource}
        <span
          style={{
            color: statusMapping(displayStatus), // <- uses the found status
            fontSize: "14px",
            fontWeight: "500",
            paddingTop: "5px",
          }}
        >
          {displayStatus}
        </span>
      </span>

      {anyHasColumnReason && hasColumnChangeReason && (
        <div
          style={{
            color: "#FF8800",
          }}
        >
          ⚠️ Column-level change detected in task(s) linked to this source.
        </div>
      )}
    </div>
  );
})}
                    </>

                  }
                  {/* ) */}
                </Card.Body>
              </Accordion.Collapse>
            </div>
          );
        })}
      </Accordion>
    );
  };

  const renderTaskGroups = (jobId: number, taskGroups: JobTaskGroupVersion2[], job_dependency_exist: boolean) => {
    const isTier1NewCheckedForJob = !!tier1NewCheckedJobs[jobId];

    const hasTier1New = taskGroups.some(
      tg => tg.job_task_group_layer_id === 1 && tg.job_task_group_status === "NEW"
    );

    const isTier2Checked = taskGroups.some(
      tg =>
        tg.job_task_group_layer_id === 2 &&
        tg.selected
    );

    // const onlyTier3Exists = taskGroups.every(
    //   tg => tg.job_task_group_layer_id===3
    // )
  
    return (
      <Accordion className="metadata-tree metadata-tree--groups">
        <div className="metadata-tree-notice-row">
           {job_dependency_exist && <span className="metadata-tree-notice">
                            Job Dependency Change Detected                             
                            </span>

              }
        </div>
        {taskGroups.map(taskGroup => {

        const hasTier2 = taskGroups.some(tg => tg.job_task_group_layer_id === 2);

        const job_task_group_dependency_exist = hasChangedDependencyStatus(
          taskGroup.job_task_group_dependency,
          "job_task_group_dependency_status"
        );
        const isDisabled = (() => {
          const layer = taskGroup.job_task_group_layer_id;
          const status = taskGroup.job_task_group_status;

          if (layer === 2) {
            return hasTier1New && !isTier1NewCheckedForJob &&
              ["NEW", "NO_CHANGE", "DELETED", "UPDATED"].includes(status);
          }

          if (layer === 3) {
            if (!hasTier2) {
              // ✅ No Tier 2 — T3 should act independently
              return false;
            }
            // 👇 Usual rule applies if T2 is present
            return !isTier2Checked &&
              ["NEW", "NO_CHANGE", "DELETED", "UPDATED"].includes(status);
          }

          return false;
        })();

        // let isChecked = taskGroup.selected;

        // if (taskGroup.job_task_group_layer_id === 2) {
        //   // If tier 1 is required and not selected, force uncheck
        //   if (hasTier1New && !isTier1NewCheckedForJob) {
        //     isChecked = false;
        //   }
        // }

        // if (taskGroup.job_task_group_layer_id === 3) {
        //   // If tier 2 is not selected, force uncheck
        //   const tier2Selected = taskGroups.some(
        //     tg => tg.job_task_group_layer_id === 2 && tg.selected
        //   );
        //   if (!tier2Selected) {
        //     isChecked = false;
        //   }
        // }
          return (
            <div
              key={taskGroup.job_task_group_id}
              className="metadata-tree-row metadata-tree-row--group"
            >
              <Card.Header
                className="metadata-tree-row__header metadata-tree-row__header--group"
              >
                <Form.Check
                  className="metadata-tree-check"
                  type="checkbox"
                  // disabled={
                  //   hasTier1New && !isTier1NewCheckedForJob &&
                  //   (taskGroup.job_task_group_layer_id === 2 || taskGroup.job_task_group_layer_id === 3) &&
                  //   ["NEW", "NO_CHANGE", "DELETED", "UPDATED"].includes(taskGroup.job_task_group_status)
                  // }
                  disabled={isDisabled}
                  label={
                    <div className="taskgroup-label">
                      <span className="taskgroup-label__name">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <div
                              id={`tooltip-${taskGroup.job_task_group_id}`}
                              style={{
                                background: "white",
                                padding: "10px",
                                borderRadius: "10px",
                                border: "1px solid black"
                              }}
                            >
                              {`${taskGroup.job_task_group_name}`}
                            </div>
                          }
                        >
                          <span className="taskgroup-label__nameText">
                            {getTierIcon(taskGroup.job_task_group_layer_id as 1 | 2 | 3)}
                            {taskGroup.job_task_group_name}
                          </span>
                        </OverlayTrigger>
                      </span>
                      <div className="taskgroup-label__status">
                        {taskGroup.job_task_group_status !== "No Change" &&
                          taskGroup.job_task_group_status !== null && (
                            <span
                              className="metadata-status-pill"
                              style={{
                                color: statusMapping(taskGroup.job_task_group_status),
                              }}
                            >
                              {taskGroup.job_task_group_status}
                            </span>
                        )}
                        {
                          taskGroup.job_task_group_status === "NO_CHANGE" && childEntityUpdate &&
                          <span
                              className="metadata-status-pill metadata-status-pill--warning"
                              style={{
                                color: 'purple',
                              }}
                            >
                              (Child Modified)
                            </span>
                        }
                      </div>
                    </div>
                  }
                  // checked={taskGroup.job_task_group_layer_id === 3 && !onlyTier3Exists? isChecked : taskGroup.selected}
                  checked={taskGroup.selected}
                  onChange={() => handleTaskGroupSelect(jobId, taskGroup.job_task_group_id)}
                />
                <Button 
                // disabled={
                //   hasTier1New && !isTier1NewCheckedForJob &&
                //   (taskGroup.job_task_group_layer_id === 2 || taskGroup.job_task_group_layer_id === 3) &&
                //   ["NEW", "NO_CHANGE", "DELETED", "UPDATED"].includes(taskGroup.job_task_group_status)
                // }
                disabled={isDisabled}
                
                className="metadata-tree-toggle"
                variant="link" onClick={() => togglePanel(taskGroup.job_task_group_id)}>
                  {expandedItems.has(taskGroup.job_task_group_id) ? (
                    <FaChevronDown />
                  ) : (
                    <FaChevronRight />
                  )}
                </Button>
              </Card.Header>
              <Accordion.Collapse
                eventKey={String(taskGroup.job_task_group_id)}
                in={expandedItems.has(taskGroup.job_task_group_id)}
              >
                <Card.Body className="metadata-tree-body metadata-tree-body--groups">
                  {renderJobTasks(jobId, taskGroup.job_task_group_id, taskGroup.job_tasks, taskGroup.job_task_group_layer_id, job_task_group_dependency_exist)}
                </Card.Body>
              </Accordion.Collapse>
            </div>
          );
        })}
      </Accordion>
    );
  };

  type Props = {
    size?: number; // optional, default fallback
    eyeSize?: number
  };

  
  const CompositeTableEyeIcon: React.FC<Props> = ({ size = 40, eyeSize=30 }) => (
    <div
      style={{
        position: 'relative',
        width: `${size}px`,
        height: `${size}px`,
        display: 'inline-block',
      }}
    >
      <FaTable size={size} color="silver" />
  
      <div
        style={{
          position: 'absolute',
          bottom: '0.05em',
          right: '0.05em',
          backgroundColor: 'white',
          borderRadius: '50%',
          padding: '0.2em',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <FaEye size={eyeSize * 0.4} color="#1a73e8" />
      </div>
    </div>
  );

  const JobListCanvas: React.FC<any> = ({ filteredItems, handleDragStart, selectedViewTargets, packageId }) => (
    <div
      className="metadata-package-canvas"
      draggable="true"
      onDragStart={(e) => handleDragStart(e, filteredItems)}
    >
      <div className="metadata-package-canvas__header">
        <>
          <span className="metadata-package-canvas__headerIcon"><FaBriefcase /></span>
          <div>
          <strong>
            {packageId ? `Deployment Package Id : ${packageId}` : 'Deployment Package'}
          </strong>
          <span>Drag & drop package cards to a deployment target</span>
          </div>
        </>
      </div>
  
      <div
        className="metadata-package-grid"
      >
        {/* CASE 1: BOTH FILTERED AND VIEWS EXIST */}
        {filteredItems?.length > 0 && selectedViewTargets?.length > 0 && (
          <>
          {/* Render all jobs if present */}
          {filteredItems?.length > 0 &&
            filteredItems.map((job: any, index: number) => (
              <Card
                key={`job-${index}`}
                className="metadata-package-tile metadata-package-tile--job"
              >
                <span className="metadata-package-tile__icon">
                <img
                  src={SettingIcon}
                  alt="job icon"
                  width={22}
                />
                </span>
                <span className="metadata-package-tile__title">{job?.job_name}</span>
              </Card>
            ))}
        
          {/* Render all view targets separately, regardless of job context */}
          {selectedViewTargets?.length > 0 &&
            selectedViewTargets.map((vt: { target_entity_name: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactFragment | React.ReactPortal; target_entity_table_constructor: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactFragment | React.ReactPortal; }, i: number) => (
              <Card
                key={`view-${i}`}
                className="metadata-package-tile metadata-package-tile--view"
              >
                <span className="metadata-package-tile__icon">
                  <CompositeTableEyeIcon size={30} eyeSize={24} />
                </span>
                <span className="metadata-package-tile__title">
                  {vt.target_entity_name}
                </span>
              </Card>
            ))}
        </>
        )}
  
        {/* CASE 2: ONLY VIEW TARGETS EXIST */}
        {filteredItems?.length === 0 && selectedViewTargets?.length > 0 && (
          <>
            {selectedViewTargets.map((vt: any, i: number) => (
              <Card
                key={`view-only-${i}`}
                className="metadata-package-tile metadata-package-tile--view"
              >
                <span className="metadata-package-tile__icon">
                  <CompositeTableEyeIcon size={30} eyeSize={24} />
                </span>
                <span className="metadata-package-tile__title">
                  {vt.target_entity_name}
                </span>
              </Card>
            ))}
          </>
        )}
  
        {/* CASE 3: ONLY JOBS EXIST */}
        {filteredItems?.length > 0 && selectedViewTargets?.length === 0 && (
          <>
            {filteredItems.map((job: any, index: number) => (
              <Card
                key={`job-only-${index}`}
                className="metadata-package-tile metadata-package-tile--job"
              >
                <span className="metadata-package-tile__icon">
                <img
                  src={SettingIcon}
                  alt="job icon"
                  width={22}
                /> 
                </span>
                <span className="metadata-package-tile__title">{job?.job_name}</span>
              </Card>
            ))}
          </>
        )}
  
        {/* CASE 4: NEITHER EXISTS */}
        {filteredItems?.length === 0 && selectedViewTargets?.length === 0 && (
          <Card
            className="metadata-package-empty-card"
          >
            <Card.Body>
              <FaDatabase />
              <Card.Title>No Jobs Available</Card.Title>
              <Card.Text>
                No jobs or view targets selected in the package.
              </Card.Text>
            </Card.Body>
          </Card>
        )}
      </div>
    </div>
  );

  const ViewTargetDetailList: React.FC<{ targets: ViewTargetInfo[] }> = ({ targets }) => (
    <div className="metadata-package-view-details">
      {targets.map((target, index) => (
        <Card
          key={`${target.target_entity_name}-${target.target_entity_table_constructor}-${index}`}
          className="metadata-package-view-card"
        >
          <Card.Header className="metadata-package-view-card__header">
            <span className="metadata-package-view-card__icon">
              <CompositeTableEyeIcon size={30} eyeSize={24} />
            </span>
            <div className="metadata-package-view-card__title">
              <h5>{target.target_entity_name}</h5>
              <span>{target.target_entity_table_constructor}</span>
            </div>
            {target.target_entity_status && (
              <span
                className="metadata-status-pill"
                style={{ color: statusMapping(target.target_entity_status) }}
              >
                {target.target_entity_status}
              </span>
            )}
          </Card.Header>
          <Card.Body className="metadata-package-view-card__body">
            <div className="metadata-package-view-card__section">
              <span className="metadata-package-view-card__sectionTitle">Target mappings</span>
              {(target.target_entity_mapping?.length ?? 0) > 0 ? (
                target.target_entity_mapping.map((mapping, mapIndex) => (
                  <div className="metadata-package-view-card__row" key={`target-map-${mapIndex}`}>
                    <span>Mapping ID {mapping.target_entity_mapping_id ?? "--"}</span>
                    {mapping.target_entity_mapping_status && (
                      <span
                        className="metadata-status-pill"
                        style={{ color: statusMapping(mapping.target_entity_mapping_status) }}
                      >
                        {mapping.target_entity_mapping_status}
                      </span>
                    )}
                  </div>
                ))
              ) : (
                <div className="metadata-package-view-card__row">
                  <span>No target mappings selected</span>
                </div>
              )}
            </div>

            <div className="metadata-package-view-card__section">
              <span className="metadata-package-view-card__sectionTitle">Source mappings</span>
              {(target.source_target_entity_mapping?.length ?? 0) > 0 ? (
                target.source_target_entity_mapping.map((mapping, mapIndex) => (
                  <div className="metadata-package-view-card__row" key={`source-map-${mapIndex}`}>
                    <span>Mapping ID {mapping.source_target_entity_mapping_id ?? "--"}</span>
                    {mapping.source_target_entity_mapping_status && (
                      <span
                        className="metadata-status-pill"
                        style={{ color: statusMapping(mapping.source_target_entity_mapping_status) }}
                      >
                        {mapping.source_target_entity_mapping_status}
                      </span>
                    )}
                  </div>
                ))
              ) : (
                <div className="metadata-package-view-card__row">
                  <span>No source mappings selected</span>
                </div>
              )}
            </div>
          </Card.Body>
        </Card>
      ))}
    </div>
  );

  
  return (
    <>
      <div className="metadata-deployment-page">
      <BreadCrumbs breadCrumbsData={importDeploymentBreadCrumbData} />
      <div className="metadata-deployment-shell">
          <div className="metadata-deployment-panel metadata-deployment-panel--jobs">
              <div className="metadata-deployment-panel__header">
                  <span className="metadata-deployment-panel__icon"><FaBriefcase /></span>
                  <h3>Deployment - Job</h3>
              </div>
              <div className="metadata-deployment-toolbar">
                <div 
                  className="metadata-deployment-steps"
                >
                  <span>
                    <img
                      src={SettingIcon}
                      alt="job icon"
                      width={20}
                    />
                    JOBS
                  </span>
                  <img src={arrowRight} alt="" />
                  <span>
                    <img
                      src={JobTaskGroupIcon}
                      alt="job icon"
                      width={20}
                    />
                    JOB TASK GROUPS
                  </span>
                  <img src={arrowRight} alt="" />
                  <span>
                    <FaTasks size={15}/>
                    JOB TASKS
                  </span>
                </div>

                <div className="metadata-deployment-compare">
                  <CompareTarget targets={environments} setSelectedTargets={setSelectedTargets} resetAllStates={resetAllStates} loading={loading}/>
                </div>
              </div>
              <Form.Check
                type="checkbox"
                label="Select All Jobs"
                checked={areAllJobsSelected(jobs)}
                onChange={handleSelectAllJobs}
                disabled={jobs?.length === 0}
                className="metadata-deployment-select-all"
              />
              {jobs?.length > 0 && !loading  ? (
                <Accordion className="metadata-deployment-jobs-list">
                  {jobs.map(job => {
                    const job_dependency_exist = hasChangedDependencyStatus(
                      job.job_dependency,
                      "job_dependency_status"
                    );
                    return(
                    <div 
                      key={job.job_id} 
                      className="metadata-tree-row metadata-tree-row--job"
                    >
                      <Card.Header className="metadata-tree-row__header metadata-tree-row__header--job">
                        <div className="metadata-tree-check metadata-tree-check--job">
                          <input
                            id={`metadata-job-${job.job_id}`}
                            className="metadata-tree-checkbox"
                            type="checkbox"
                            checked={job.selected}
                            onChange={() => handleJobSelect(job.job_id)}
                          />
                          <label
                            className="metadata-tree-check-label"
                            htmlFor={`metadata-job-${job.job_id}`}
                          >
                          <div className="deployment-job-card__meta">
                          <span className="deployment-job-card__title">
                            <img
                              src={SettingIcon}
                              alt="job icon"
                              width={20}
                            />
                            {job.job_name}
                          </span>
                          <div className="deployment-job-card__status">
                          {job.job_status	!== "No Change" && job.job_status	!== null && <span className="metadata-status-pill" style={{
                            color:statusMapping(job.job_status)
                            }}
                            >{job.job_status}</span>
                          }
                          {
                          job.job_status === "NO_CHANGE" && childEntityUpdate &&
                          <span className="metadata-status-pill metadata-status-pill--warning"
                              style={{ color: 'purple'}}
                            >
                              (Child Modified) 
                            </span>
                          }
                          </div>
                        </div>
                          </label>
                        </div>
                        <Button className="metadata-tree-toggle" variant="link" onClick={() => togglePanel(job.job_id)}>
                          {expandedItems.has(job.job_id) ? <FaChevronDown /> : <FaChevronRight />}
                        </Button>
                      </Card.Header>
                      <Accordion.Collapse eventKey={String(job.job_id)} in={expandedItems.has(job.job_id)}>
                        <Card.Body className="metadata-tree-body metadata-tree-body--jobs">{renderTaskGroups(job.job_id, job.job_task_groups, job_dependency_exist)}</Card.Body>
                      </Accordion.Collapse>
                    </div>
                    )
                  })}
                </Accordion>
              ) :
                <>
                  <ToastContainer position="top-end" className="p-3">
                    <Toast
                      bg="warning"
                      onClose={() => setEmptyResultWarning(false)}
                      show={emptyResultWarning}
                      delay={5000}
                      autohide
                    >
                      <Toast.Header>
                        <strong className="me-auto">Notice</strong>
                      </Toast.Header>
                      <Toast.Body>The result list is empty after comparison.</Toast.Body>
                    </Toast>
                  </ToastContainer>
                  <CenteredModal
                    show={showInitialSelectionModalLoader}
                    message="Fetching Job Lists ..........., Please Wait !!!"
                  />
                  <div className="metadata-deployment-empty metadata-deployment-empty--jobs">
                    <img src={Wait} alt="Compare target before loading jobs" />
                    <h1>WAIT, LOOK UP !!</h1>
                    <p>First You Need To Compare</p>
                    <p>Target Environment,</p>
                  <p>To get Updated Job List</p>
                  </div>
                </>
              }
          </div>
          <div className="metadata-deployment-panel-group">
          <div className="metadata-deployment-panel metadata-deployment-panel--package">
              <div className="metadata-deployment-panel__header">
                <span className="metadata-deployment-panel__icon"><FaTable /></span>
                <h3>Deployment - Package</h3>
              </div>
              
              { !(showProgress)?
              <>
                {filteredItems?.length > 0 && 
                  <div style={{ height: 'calc(50% - 70px)', marginBottom: '20px' }}>
                      <div style={{
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}>
                        <JobListCanvas filteredItems={filteredItems} handleDragStart={handleDragStart} selectedViewTargets={selectedViewTargets}/>
                      </div>
                  </div>
                }
                {selectedViewTargets?.length > 0 && filteredItems?.length === 0 &&
                  <div style={{ height: 'calc(50% - 70px)', marginBottom: '20px' }}>
                      <div style={{
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}>
                        <JobListCanvas filteredItems={filteredItems} handleDragStart={handleDragStart} selectedViewTargets={selectedViewTargets}/>
                      </div>
                  </div>
                }

                <div className="metadata-package-selected-list">
                  {filteredItems?.length > 0 || selectedViewTargets?.length > 0 ? (
                    <>
                      {filteredItems?.map((job, index) => (
                        <div key={`selected-job-${index}`}>
                          <DetailCard job={[job]} packageId={null} canvas={true}/>
                        </div>
                      ))}
                      {filteredItems?.length === 0 && selectedViewTargets?.length > 0 && (
                        <ViewTargetDetailList targets={selectedViewTargets} />
                      )}
                    </>
                  )
                  : (
                    <div className="metadata-deployment-empty metadata-deployment-empty--package">
                      <Card style={{ border: 'none', backgroundColor: 'transparent' }}>
                        <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                          <div>
                            <img src={empty} alt="No deployment package selected" />
                          </div>
                          <h1>NOTHING!!</h1>
                          <p>Your Deployment list is empty.</p>
                        </Card.Body>
                      </Card>
                    </div>
                  )}
                </div>
              </>
              :
              <>
                <div style={{maxHeight:"85%", overflowY:"auto"}}>
                  <DetailCard job={jobToShowProgressFor} packageId={1} canvas={false}/>
                </div>
              </>
              }
            </div>
            <div className="metadata-deployment-panel metadata-deployment-panel--targets">
              <div className="metadata-deployment-panel__header">
                  <span className="metadata-deployment-panel__icon"><FaDatabase /></span>
                  <h3>Deployment - Target</h3>
              </div>

              <div
                className="metadata-deployment-target-list"
              >
                {environments.map((env: Environment, index: number) => {
                    if (env.is_master) {
                      return null;
                    }

                    const foundJobData = storedJobsArray.find((storedItem: any) => storedItem.envName === env.environment_type);

                    return (
                      foundJobData && foundJobData.jobData?.length > 0
                      ? (
                        <DropZoneCard
                          key={index}
                          index={index}
                          job={foundJobData.jobData}
                          type={foundJobData.envName}
                          name={foundJobData.customer_environment_name}
                          handleJobDrop={handleJobDrop}
                          handleJobCompletion={handleJobCompletion}
                          packageId={packageId}
                          disabled={false} 
                          setShowProgress={setShowProgress}
                          setJobsToShowProgressFor={setJobsToShowProgressFor}
                          alreadyRunning={true}
                          setJobs={setJobs}
                          selectedTargets={setSelectedTargets}
                          selectedTargetsV2={selectedTargets}
                          env = {env}
                          initialJobList={initialJobList}
                          setPackageId={setPackageId}
                          tableNames={tableNames}
                          views={selectedViewTargets}
                          targetEnvironmentId={targetEnvironmentId}
                        />
                      ) : (
                        <DropZoneCard
                          key={index}
                          index={index}
                          job={droppedJobs[index]}
                          type={env.environment_type}
                          name={env.customer_environment_name}
                          handleJobDrop={handleJobDrop}
                          handleJobCompletion={handleJobCompletion}
                          packageId={packageId}
                          disabled={selectedTargets === env.environment_type || packageDeploymentExecution.includes(env.environment_type) ? false : true}
                          setShowProgress={setShowProgress}
                          setJobsToShowProgressFor={setJobsToShowProgressFor}
                          alreadyRunning={false}
                          setJobs={setJobs}
                          selectedTargets={setSelectedTargets}
                          selectedTargetsV2={selectedTargets}
                          env = {env}
                          initialJobList={initialJobList}
                          setPackageId={setPackageId}
                          tableNames={tableNames}
                          views={selectedViewTargets}
                          targetEnvironmentId={targetEnvironmentId}
                        />
                      )
                    );
                  })}
              </div>
            </div>
            
          </div>
        </div>
        {isDragging && draggedElement && (
        <div
          style={{
            position: 'fixed',
            top: position.y + 10,
            left: position.x + 10,
            pointerEvents: 'none',
            opacity: 1,
            zIndex: 1000,
            background: 'rgba(255, 255, 255, 0.8)', 
            padding: '10px',
            color: '#103057', 
            borderRadius: '15px',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', 
            minWidth: '200px',
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          <span>{draggedElement.job_name}</span>
        </div>
      )}
      </div>
    </>
  );
};


export default JobList;
